module.exports = __webpack_public_path__ + "img/raindrops.4ddfab83.svg";